import {
    Autocomplete, Button, Card, Dialog, DialogContent, DialogTitle,
    Divider, Grid, IconButton, Slide, TextField,
    Typography
} from "@mui/material";
import { IconCircleX } from "@tabler/icons-react";
import { IconAdjustmentsHorizontal, IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import React, { forwardRef, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { getRoleOptions, setUserFilteredData } from "store/app/user-management/actions";
import debounce from "lodash.debounce";

const styles = {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        display: "none",
    },
    "& input[type=number]": {
        MozAppearance: "textfield",
    },
}
const Transition = forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

const userStatusOption = [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
]

const accountStatusOption = [
    { label: "Enabled", value: true },
    { label: "Disabled", value: false },
]

const FilterUsers = (props) => {

    const { open, onClose, userFilterData } = props;

    const [isAutoOpenRole, setIsAutoOpenRole] = useState();
    const [isAutoOpenUserStatus, setIsAutoOpenUserStatus] = useState();
    const [isAutoOpenAccountStatus, setIsAutoOpenAccountStatus] = useState();
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState();

    useEffect(() => {
        if (userFilterData) {
            setFilter(userFilterData);
        }
        else {
            setFilter(null);
        }
    }, [open]);

    const validateOnchange = (e) => {
        const { name, value } = e.target;
        if ((name === "asignedstatecount") && Number(value) > 10000000) {
            return;
        }
        setFilter({
            ...filter,
            [name]: value,
        });
    }

    const handleSelect = (e, option, name) => {
        if (name === "role") {
            const optionArray = option?.map((field) => field.label ? field.label : field);
            const optionString = optionArray?.length > 0 ? optionArray.join() : null;
            setFilter({
                ...filter,
                [name]: optionString,
            });
        }
        else {
            const { label } = option || {};
            setFilter({
                ...filter,
                [name]: label,
            });
        }

    }

    const loadRoleOptions = (filter) => {
        setLoading(true);
        props.getRoleOptions(filter)
            .then((results) => {
                setOptions(results);
                setLoading(false);
            })
            .catch(() => {
                setOptions([]);
                setLoading(false);
            })
    }

    const handleFilter = (e) => {
        e.preventDefault();
        onClose();
        const nonEmptyData = removeEmptyKeys(filter);
        props.setUserFilteredData(nonEmptyData);
    }
    const handleFilterClear = (e) => {
        e.preventDefault();
        onClose();
        props.setUserFilteredData();
    }

    //---------------FILTER DROP DOWN------------------------------
    const debouncedFetchOptions = useMemo(() => debounce((query) => loadRoleOptions(query), 500), []);

    const handleFilterRole = (e) => {
        const { value } = e?.target || {};
        debouncedFetchOptions(value);
    };

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }
    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                maxWidth={'xs'}
                fullWidth
                keepMounted
                onClose={validateClose}
                sx={{
                    '&>div:nth-of-type(3)': {
                        justifyContent: 'flex-end',
                        '&>div': {
                            m: 0,
                            borderRadius: '10px 0px 0px 10px',
                            maxWidth: 450,
                            maxHeight: '100%'
                        }
                    }
                }}
            >
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Filters
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={3} justifyContent={'center'} direction={'column'}>
                                            <Grid item >
                                                <TextField
                                                    autoFocus
                                                    label="Display Name"
                                                    fullWidth
                                                    size="small"
                                                    name='displayname'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.displayname}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Autocomplete
                                                    size="small"
                                                    disablePortal
                                                    freeSolo
                                                    multiple
                                                    filterSelectedOptions
                                                    isOptionEqualToValue={(option, value) => option?.label === value}
                                                    options={options}
                                                    open={isAutoOpenRole}
                                                    loading={loading}
                                                    onOpen={() => {
                                                        setIsAutoOpenRole(true);
                                                        loadRoleOptions();
                                                    }}
                                                    onClose={() => setIsAutoOpenRole(false)}
                                                    onChange={(e, option) => handleSelect(e, option, 'role')}
                                                    // value={userFilterData?.role}
                                                    value={filter?.role ? filter.role.includes(",") ? filter.role.split(",") : [filter.role] : []}
                                                    onInputChange={handleFilterRole}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            label="Role"
                                                        />
                                                    }
                                                    renderOption={(props, option) => (
                                                        <li {...props} key={option?.value}>
                                                            {option?.label}
                                                        </li>
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Autocomplete
                                                    size="small"
                                                    disablePortal
                                                    options={userStatusOption}
                                                    open={isAutoOpenUserStatus}
                                                    loading={loading}
                                                    onOpen={() => setIsAutoOpenUserStatus(true)}
                                                    onClose={() => setIsAutoOpenUserStatus(false)}
                                                    onChange={(e, option) => handleSelect(e, option, 'userstatus')}
                                                    value={filter?.userstatus}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            label="User Status"
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Autocomplete
                                                    size="small"
                                                    disablePortal
                                                    options={accountStatusOption}
                                                    open={isAutoOpenAccountStatus}
                                                    loading={loading}
                                                    onOpen={() => setIsAutoOpenAccountStatus(true)}
                                                    onClose={() => setIsAutoOpenAccountStatus(false)}
                                                    onChange={(e, option) => handleSelect(e, option, 'accountstatus')}
                                                    value={filter?.accountstatus}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            label="Account Status"
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item >
                                                <TextField
                                                    label="Email Address"
                                                    fullWidth
                                                    size="small"
                                                    name='emailaddress'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.emailaddress}
                                                />
                                            </Grid>
                                            <Grid item >
                                                <TextField
                                                    label="First Name"
                                                    fullWidth
                                                    size="small"
                                                    name='firstname'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.firstname}
                                                />
                                            </Grid>
                                            <Grid item >
                                                <TextField
                                                    label="Last Name"
                                                    fullWidth
                                                    size="small"
                                                    name='lastname'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.lastname}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    label="Mobile Number"
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='mobilenumber'
                                                    type='number'
                                                    onKeyDown={
                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                    }
                                                    onChange={validateOnchange}
                                                    value={filter?.mobilenumber}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    sx={styles}
                                                    label="Assigned States/Export Count"
                                                    fullWidth
                                                    size="small"
                                                    name='asignedstatecount'
                                                    type='number'
                                                    onChange={validateOnchange}
                                                    value={filter?.asignedstatecount}
                                                    onKeyDown={
                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                    }
                                                    inputProps={{ max: 10000000 }}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    sx={{ mt: 2, mb: 2 }}
                                                >
                                                    Note: Counts can only be entered up to <b>1,00,00,000</b>.
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleFilter}
                                                size="small"
                                                color="primary"
                                                startIcon={<IconAdjustmentsHorizontal />}
                                            >
                                                Apply Filters
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={handleFilterClear}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                                startIcon={<IconCircleX />}
                                            >
                                                Clear
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    userFilterData: state.users.userFilterData,
})
const mapDispatchToProps = (dispatch) => ({
    setUserFilteredData: (filter) => dispatch(setUserFilteredData(filter)),
    getRoleOptions: (filter) => dispatch(getRoleOptions(filter)),

})

export default connect(mapStateToProps, mapDispatchToProps)(FilterUsers);